import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => {
  return {
    dateTimePicker: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      alignSelf: 'flex-start',
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    dateContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    aspectRatioContainer: {
      marginLeft: '-10px',
    },
    runActionContainer: {
      marginLeft: '-8px'
    },
    searchBar: {
      backgroundColor: 'transparent',
      width: '100%',
      marginRight: '1vh',
      '&.MuiFilledInput-root:hover': {
        backgroundColor: 'transparent',
      },
      '&.MuiInputBase-root :hover': {
        backgroundColor: 'transparent',
      },
      fontSize: 'larger',
    },
    searchContainer: {
      marginRight: '10px'
    }
  };
});

export default styles;
